import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const SmokingShape = ({
  width = 800,
  height = 800,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    fill={fillColor}
    height={height}
    width={width}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 507.58 507.58"
    xmlSpace="preserve"
    style={style}
  >
    <g>
      <g>
        <g>
          <path
            d="M192.009,264.459c11.797,0,21.333-9.557,21.333-21.333c0-41.579,17.28-64,33.515-64h45.717
    c9.109,0,17.216-5.781,20.16-14.4c2.987-8.619,0.149-18.155-7.04-23.765c-3.797-2.944-10.069-18.325-10.069-30.272
    c0-4.181,0-16.896,24.384-16.896c11.797,0,21.333-9.557,21.333-21.333s-9.536-21.333-21.333-21.333
    c-40.107,0-67.051,23.936-67.051,59.563c0,7.829,1.301,16.853,3.819,25.771h-9.92c-44.139,0-76.181,44.864-76.181,106.667
    C170.675,254.901,180.211,264.459,192.009,264.459z"
          />
          <path
            d="M505.237,222.532l-22.656-44.373c-2.581-5.056-7.083-8.896-12.48-10.624c-5.44-1.728-11.328-1.237-16.363,1.408
    L229.461,285.786H36.864c-1.237,0-2.432,0.107-3.648,0.32C13.973,289.455,0,306.586,0,326.874v91.307
    c0,12.075,4.949,23.168,13.568,30.421c6.912,5.845,15.765,8.597,24.64,7.68h307.584c1.109,0.107,2.197,0.171,3.307,0.171
    c7.723,0,15.275-2.752,21.355-7.851C379.072,441.348,384,430.255,384,418.18v-91.307c0-5.568-1.131-10.859-3.051-15.723
    l115.136-60.011C506.496,245.743,510.571,232.964,505.237,222.532z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SmokingShape;
